export function getMaterial(data) {
    return new Promise((resolve, reject) => {
        let { getMaterialRequest, getMaterialError, getMaterialResult } = this.props

        this.doAction(
            this.WEB_REQUEST_URL + 'get_material',
            this.createBundle(
                'get_material',
                { materialId: data },
                this.GET,
                getMaterialRequest,
                (result) => {
                    getMaterialResult(result)
                    resolve(result)
                },
                (error) => {
                    getMaterialError(error)
                    reject(error)
                }
            )
        )
    })
}
